import { render, staticRenderFns } from "./SharingViewHistory.vue?vue&type=template&id=5bea6fe4&scoped=true&"
import script from "./SharingViewHistory.vue?vue&type=script&lang=ts&"
export * from "./SharingViewHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SharingViewHistory.vue?vue&type=style&index=0&id=5bea6fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea6fe4",
  null
  
)

export default component.exports